<template>
  <div class="page7">
    <div class="bottom"></div>
    <div class="main">
      <div class="bg" @click="jump"></div>
      <img @click="jump" class="back" src="../../static/img/back.png" alt="" />
      <img class="pic" src="../../static/img/spdq.png" alt="" />
      <img class="name" src="../../static/img/spdq-tl.png" alt="" />
      <div class="word">
        <div>
          从车坊大桥向东继续行驶约10公里，就看到了胜浦大桥。按计划新桥建成后老桥将拆除。
        </div>
        <div>
          胜浦大桥是沟通胜浦和甪直两地的重要通道，现有老桥建于1995年，仅满足五级航道的通航要求。近年来，该桥交通流量逐年增加，且老桥已被鉴定为限制性桥梁，严重阻碍了两地居民的出行交往。
        </div>
        <div>
          新胜浦大桥桥宽达47米，双向八车道，预计2022年底建成通车。新桥建成将显著改善两岸群众的出行条件，也将全面提升内港线全线的通航能力，促进完善苏州内河高等级航道网，从而更好地服务苏州地方经济的发展。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    jump() {
      this.$router.push("/page1");
    },
  },
  mounted() {
    let Main = document.querySelector(".main");
    let MainW = Main.getBoundingClientRect().width;
    Main.style.height = (MainW / 750) * 1500 + "px";
  },
};
</script>

<style scoped>
.page7 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.page7 .bottom{
  position:absolute;
  width:100%;
  height:100%;
  top:0;
  left:0;
  background: #89d7c6;
  opacity:0.5;
}
.page7 .main {
  position: absolute;
  left: 0;
  top: -100%;
  bottom: -100%;
  margin: auto;
  width: 100%;
  height: auto;
}
.page7 .bg {
  position: absolute;
  /* width: 50%;
  height: 50%;
  background: url("../../static/img/page2-bg.jpg");
  background-size: 100% 100%;
  top:calc((100vh - 50%) / 2);
  left:calc((100vw - 50%) / 2); 
  border-radius: 50%;
  animation: bgdh 1s linear 1;
  animation-fill-mode: forwards; */
    width: 100%;
   height: 100%;
   background: url("../../static/img/page2-bg.jpg");
   background-size: 100% 100%;
   border-radius: 50%;
   transform: scale(0.2);
   animation: bgdh 0.5s linear 1;
   animation-fill-mode: forwards;
}
.back {
  width: 10.13%;
  position: absolute;
  top: 71%;
  left: 10%;
  opacity:0;
  animation: show 2s 0.5s linear 1;
  animation-fill-mode: forwards;
}
.pic {
  width: 52.19%;
  position: absolute;
  top: 13%;
  left: 17%;
  opacity: 0;
  animation: show 2s 1.5s linear 1;
  animation-fill-mode: forwards;
}
.name {
  width: 13.07%;
  position: absolute;
  top: 12%;
  left: 74%;
   opacity:0;
  animation: show 2s 0.5s linear 1;
  animation-fill-mode: forwards;
}
.word {
  width: 67%;
  height: 24%;
  position: absolute;
  left: 16%;
  top: 61%;
  transform:rotateZ(90deg);
  /* background:gray; */
  overflow: auto;
  color: #17848b;
  text-indent: 42px;
  line-height: 28px;
  letter-spacing: 5px;
  opacity: 0;
  animation: show 2s 2s linear 1;
  animation-fill-mode: forwards;
}
@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* @keyframes bgdh {
  0%{
    width: 50%;
    height: 50%;
    border-radius: 50%;
    top:calc((100vh - 50%) / 2);
    left:calc((100vw - 50%) / 2);
  }
  100%{
    width: 100%;
    height: 100%;
    border-radius: 0;
    top:0;
    left:0;
  }
} */

@keyframes bgdh {
  0%{
    border-radius: 50%;
    transform: scale(0.2)
  }
  100%{
    border-radius: 0 ;
    transform: scale(1)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page7.vue